<template>
  <v-card>
    <div class="pt-6">
      <v-card flat>
        <v-row class="d-flex justify-space-between padding-bottom">
          <div>
            <v-btn
                depressed
                color="primary"
                v-on:click="back()">
              返回
            </v-btn>
          </div>
        </v-row>
        <v-row class="mt-8">
          <v-tabs v-model="tab" background-color="primary" dark>
            <v-tab
                v-for="item in items"
                :key="item.tab"
                :href="'#tab-' + item.tab"
                @change="tabChange(item.id)">
              {{ item.tab }}
            </v-tab>
          </v-tabs>
          <v-row class="mt-5 pl-3">
            <v-col cols="15" sm="3" style="text-align: right">
              <label>维保达成率：</label>
            </v-col>
            <v-col cols="15" sm="3">
              <label>{{ desserts.reachRate }}</label>
            </v-col>
            <v-col cols="15" sm="3" style="text-align: right">
              <label>主管复检率：</label>
            </v-col>
            <v-col cols="15" sm="3">
              <label>{{ desserts.directorRecheckRate }}</label>
            </v-col>
            <v-col cols="15" sm="3" style="text-align: right">
              <label>经理复检率：</label>
            </v-col>
            <v-col cols="15" sm="3">
              <label>{{ desserts.managerRecheckRate }}</label>
            </v-col>
          </v-row>
          <v-tabs-items v-model="tab" style="width:100%;">
            <v-simple-table
                fixed-header
                height="850px"
            >
              <template v-slot:default>
                <thead>
                <tr>
                  <th class="text-center" rowspan="3" style="width: 100px; min-width: 100px;">
                    事项编号
                  </th>
                  <th class="text-center" rowspan="3" style="width: 100px; min-width: 100px;">
                    所属科目
                  </th>
                  <th class="text-center" rowspan="3" style="width: 150px; min-width: 150px;">
                    业务事项
                  </th>
                  <th class="text-center" rowspan="3" style="width: 100px; min-width: 100px;">
                    自维/外委
                  </th>
                  <th class="text-center" rowspan="3" style="width: 200px; min-width: 200px;">
                    维保内容
                  </th>
                  <th class="text-center" rowspan="3" style="width: 100px; min-width: 100px;">
                    是否补录
                  </th>
                  <th class="text-center" rowspan="3" style="width: 100px; min-width: 100px;">
                    是否完成
                  </th>
                  <th class="text-center" rowspan="3" style="width: 100px; min-width: 100px;">
                    是否完成工程主管复检
                  </th>
                  <th class="text-center" rowspan="3" style="width: 100px; min-width: 100px;">
                    是否完成工程经理复检
                  </th>
                </tr>
                </thead>
                <tbody>
                <tr v-for="(item,index) in desserts.orderList">
                  <td class="text-center">{{ item.itemCode }}</td>
                  <td class="text-center">{{ item.subjectName }}</td>
                  <td class="text-center">{{ item.itemName }}</td>
                  <td class="text-center">{{ item.type == 1 ? "自维" : "外委" }}</td>
                  <td class="text-center">{{ item.wbContent }}</td>
                  <td class="text-center">{{ item.isModified == 1 ? "是" : "否" }}</td>
                  <td class="text-center">{{ item.isComplete == 1 ? "是" : "否" }}</td>
                  <td class="text-center">{{ item.isSupervisorRecheck == 1 ? "是" : "否" }}</td>
                  <td class="text-center">{{ item.isManagerRecheck == 1 ? "是" : "否" }}</td>
                </tr>
                </tbody>
              </template>
            </v-simple-table>
          </v-tabs-items>
        </v-row>
      </v-card>
    </div>
  </v-card>
</template>

<script>
import {default as PlanReachApi} from "@/api/pd/plan/PlanReachApi.js";

export default {
  props: {
    shopId: [Number, String],
    year: [Number, String],
    month: [Number, String],
    buttonPriviledgeList: {
      type: Array,
      default: []
    }
  },
  data() {
    return {
      tab: null,
      items: [
        {tab: "一月", id: 1},
        {tab: "二月", id: 2},
        {tab: "三月", id: 3},
        {tab: "四月", id: 4},
        {tab: "五月", id: 5},
        {tab: "六月", id: 6},
        {tab: "七月", id: 7},
        {tab: "八月", id: 8},
        {tab: "九月", id: 9},
        {tab: "十月", id: 10},
        {tab: "十一月", id: 11},
        {tab: "十二月", id: 12},
      ],

      // headers: [
      //   {text: "事项编号", value: "itemCode", width: 100, sortable: false},
      //   {text: "所属科目", value: "subjectName", width: 120, sortable: false},
      //   {text: "业务事项", value: "itemName", width: 200, sortable: false},
      //   {text: "自维/外委", value: "type", width: 100, sortable: false},
      //   {text: "维保内容", value: "wbContent", width: 200, sortable: false},
      //   {text: "是否补录", value: "isModified", width: 100, sortable: false},
      //   {text: "是否完成", value: "isComplete", width: 100, sortable: false},
      //   {text: "是否完成工程主管复检", value: "isSupervisorRecheck", width: 100, sortable: false},
      //   {text: "是否完成工程经理复检", value: "isManagerRecheck", width: 100, sortable: false},
      // ],
      desserts: {},
      loading: false,
    };
  },
  mounted() {
    // 默认取1
    this.getDataFromApi();
  },
  methods: {
    back() {
      this.$emit("back")
    },
    // 切换分类
    tabChange(month) {
      this.getDataFromApi(month)
    },
    async getDataFromApi(month) {
      let me = this;
      this.loading = true;
      this.desserts = {};
      if (!month) {
        month = 1;
      }
      let queryUserResp = await PlanReachApi.detail({
        shopId: me.shopId,
        year: me.year,
        month: month
      });
      let data = queryUserResp.data;
      console.log(data);
      me.loading = false;
      if (!data || !data.code || data.code != 200) {
        let msg = data.msg;
        msg = !msg || msg == "" ? "获取维保实施达成率详情失败" : msg;
        throw new Error(msg);
      }
      if (!data.data) {
        throw new Error("获取维保实施达成率详情情况失败(无会话数据)");
      }
      if (data.code == 200 && data.data) {
        me.desserts = data.data;
      }
    },
    _hasButtonPermission(name) {
      let buttonPriviledgeList = this.buttonPriviledgeList
      let hasButton = false
      for (let i = 0; i < buttonPriviledgeList.length; i++) {
        if (buttonPriviledgeList[i].name == name) {
          if (buttonPriviledgeList[i].hasPriviledge == 'Y') {
            return true
          } else {
            return false
          }
        }
      }
      return false
    }
  }
};
</script>
<style scoped>
.scroll-wrapper {
  overflow-y: auto;
}

th, td {
  border-right: thin solid rgba(0, 0, 0, 0.12);
}

.padding-bottom {
  padding: 0 16px;
  /**padding-bottom: 12px;**/
}

.padding-top {
  padding-top: 30px;
}

.margin-right {
  margin-right: 12px;
}
</style>